import React from 'react'
import PropTypes from 'prop-types'
import { useConnect } from 'sb-redux-hook'
import { links } from 'common/helpers'

import FooterCollectEmailForm from 'components/layout/Footer/FooterCollectEmailForm/FooterCollectEmailForm'
import WidthContainer from 'components/_new/layout/widthContainer/WidthContainer/WidthContainer'
import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Logo from 'components/ui/Logo/Logo'

import FooterLinks from './FooterLinks/FooterLinks'
import FooterSocials from './FooterSocials/FooterSocials'
import FooterCopyright from './FooterCopyright/FooterCopyright'

import messages from './messages'
import s from './Mobile.scss'


const FooterMobile = () => {
  const { gender } = useConnect({ gender: 'models.me.gender' })

  const isMale    = gender === 'male'
  const logoLink  = isMale ? links.homeMen : links.home

  return (
    <Box className={s.footer} pt="48" pb="48">
      <Text color="white" size="14-24">
        <WidthContainer>
          <Box mb="48" alignCenter>
            <Logo className={s.logo} light redirect={logoLink} />
          </Box>
          <Box mt="16" mb="16">
            <FooterCollectEmailForm
              text={messages.text}
              isHumble
            />
          </Box>
          <FooterLinks />
          <FooterSocials />
          <FooterCopyright />
        </WidthContainer>
      </Text>
    </Box>
  )
}

FooterMobile.contextTypes = {
  globals: PropTypes.object.isRequired,
}


export default FooterMobile
